import { useNavigate } from "react-router-dom";
import Footer from "../Footer/ReportFooter";
import ReportNav from "../NavBar/ReportNav";
import { CheckRounded, CloseRounded } from "@mui/icons-material";

const ReportChoiceDisplay = ({ content, userSelectedItem }) => {
  let status = "default";
  if (content.correct) {
    status = "correct";
  } else if (userSelectedItem) {
    status = "incorrect";
  }

  const config = {
    correct: {
      border: "solid 2px var(--green)",
      bg: "var(--green)",
      text: "Correct Answer",
      icon: <CheckRounded color="iconWhite" fontSize="small" />,
    },
    incorrect: {
      border: "solid 2px var(--red)",
      bg: "var(--red)",
      text: "Your Answer",
      icon: <CloseRounded color="iconWhite" fontSize="small" />,
    },
    default: {
      border: "solid 2px var(--borderColor)",
      bg: "var(--borderColor)",
      text: "",
      icon: null,
    },
  }[status];

  return (
    <div className="report-choice" style={{ border: config.border }}>
      <div
        className="report-icon"
        style={{
          backgroundColor: config.bg,
          width: "27px",
        }}
      >
        {config.icon}
      </div>
      <p className="content choice mb-0">{content.choice}</p>
      <small>{config.text}</small>
    </div>
  );
};

const ReportQuestionCard = ({ content, questionPosition }) => {
  return (
    <div className="exam-results-card">
      <div className="results-header">
        <p>
          <b>Question {questionPosition}</b>
        </p>
        {content.is_correct ? (
          <p>
            <CheckRounded
              color="success"
              sx={{ marginRight: "0.5" }}
              fontSize="small"
            />{" "}
            1 / 1 pts
          </p>
        ) : (
          <p>
            <CloseRounded
              color="error"
              sx={{ marginRight: "0.5" }}
              fontSize="small"
            />{" "}
            0 / 1 pts
          </p>
        )}
      </div>

      <p className="results-question-content"> {content.question}</p>
      <div className="choices-results-container">
        {content.choices.map((item) => {
          const userSelectedItem = content.user_selected.includes(
            String(item.id),
          );
          return (
            <ReportChoiceDisplay
              key={item.id}
              content={item}
              userSelectedItem={userSelectedItem}
            />
          );
        })}
      </div>
    </div>
  );
};

const ExamResults = ({ name, questions }) => {
  return (
    <div className="report-exam-container">
      {questions.map((item, index) => {
        return (
          <ReportQuestionCard
            content={item}
            questionPosition={index + 1}
            key={`question-${index}`}
          />
        );
      })}
    </div>
  );
};

const ExamReportContent = ({ report }) => {
  const name = report?.exam_name || "Not Avaliable";
  const navigate = useNavigate();

  function goHome() {
    navigate("/exams");
  }

  function restartExam(e) {
    e.preventDefault();
    const encodedName = encodeURIComponent(name);
    navigate(`/${encodedName}/`);
  }
  return (
    <>
      <ReportNav
        examName={name}
        totalCorrect={report?.correct_count || 0}
        total={report?.total_count || 0}
      />
      <ExamResults name={name} questions={report?.questions || []} />
      <Footer onHomeClick={goHome} onRetryClick={restartExam} />
    </>
  );
};

export default ExamReportContent;
